(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.RatingsTabController = (function(superClass) {
    extend(RatingsTabController, superClass);

    function RatingsTabController(scope, transitions, repo, modal, state) {
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.modal = modal;
      this.state = state;
      this.hasLineup = bind(this.hasLineup, this);
      this.openRatingsDialog = bind(this.openRatingsDialog, this);
      RatingsTabController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.openRatingsDialog = this.openRatingsDialog;
      this.scope.hasLineup = this.hasLineup;
      this.scope.$watch('selected.crop', (function(_this) {
        return function(crop) {
          return _this.openRatingsDialog(crop);
        };
      })(this));
    }

    RatingsTabController.prototype.openRatingsDialog = function(crop) {
      if ((crop != null ? crop.lineups_id : void 0) == null) {
        return;
      }
      return this.state.go('portal.ratings.ratings.dialog', {
        crop: crop.name.toLowerCase()
      });
    };

    RatingsTabController.prototype.hasLineup = function(crop) {
      return (crop != null ? crop.lineups_id : void 0) != null;
    };

    return RatingsTabController;

  })(Controller);

}).call(this);
